import { render, staticRenderFns } from "./AdyenPaymentMethodGroup.vue?vue&type=template&id=47068cd1"
import script from "./AdyenPaymentMethodGroup.vue?vue&type=script&lang=js"
export * from "./AdyenPaymentMethodGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports